"use client";
import NavItem from "./NavItem";
function Navigation({ setShowMenu, showMenu, links }) {
  return (
    <nav
      onClick={() => setShowMenu(false)}
      className={`absolute ${showMenu ? "left-0" : "-left-[25.5rem]"} top-20 z-20 rounded-xl bg-teal p-16 py-6 pl-4 pr-10 font-bold text-white transition-all duration-1000 md:relative md:left-0 md:top-0 md:block md:rounded-none md:bg-transparent md:p-0 md:py-0 md:pr-0`}
    >
      <ul className="leading-10 md:flex md:space-x-8 md:px-0 md:leading-none">
        {links.map((link, o) => (
          <NavItem key={o} href={link.refer}>
            {link.name}
          </NavItem>
        ))}
      </ul>
    </nav>
  );
}

export default Navigation;
